import { useQueries } from "@tanstack/react-query";
import type { AuditNoteEntry } from "models";
import { getAuditDetails } from "services/auditService";
import { auditDashboardAuditDetailsQueryKey } from "./useAuditDashboardAuditDetails";

export interface AuditDashboardShiftCashierNotes {
  auditId: string;
  notes: AuditNoteEntry[];
}

export function useAuditDashboardShiftCashierNotes(
  storeId: string | null | undefined,
  auditIds: string[],
  enabled = true
): AuditDashboardShiftCashierNotes[] {
  const isEnabled = Boolean(enabled && storeId);
  const notesByShift = useQueries({
    queries: auditIds.map((auditId) => ({
      queryKey: auditDashboardAuditDetailsQueryKey(storeId, auditId),
      queryFn: () => getAuditDetails(storeId!, auditId),
      enabled: Boolean(isEnabled && auditId),
    })),
    combine: (results) => results.map((result, index) => ({
      auditId: auditIds[index],
      notes: result.data?.noteEntries ?? [],
    })),
  });

  return isEnabled ? notesByShift : [];
}
